"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _utilities = _interopRequireDefault(require("../../utilities"));

var _constant = require("./constant");

var setLocalStorageCookieExpiryDate = function setLocalStorageCookieExpiryDate(days) {
  var currentDate = new Date();
  var newExpiryDate = new Date(currentDate.setDate(currentDate.getDate() + days));

  _utilities.default.setLocalStorage(_constant.LOCAL_STORAGE_EXPIRY_KEY, newExpiryDate.toISOString());
};

var checkDateIfExpired = function checkDateIfExpired(date) {
  return new Date(date) <= new Date();
};

var getCookieBase = function getCookieBase(cookie) {
  var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return "".concat(encodeURIComponent(cookie.split(';')[0].split('=')[0]), "=; expires=Thu, 01-Jan-1970 00:00:01 GMT;domain=").concat(domain, "; path=");
};

var clearCookie = function clearCookie(cookieString, cookieStringNoDomainAndPath) {
  document.cookie = cookieString;
  document.cookie = cookieStringNoDomainAndPath;
};

var checkCookieExemption = function checkCookieExemption(cookie) {
  var cookieSplit = cookie.split('=');
  var cookieName = cookieSplit && cookieSplit.length > 0 ? cookieSplit[0] : null;

  if (cookieName) {
    var isExempted = _constant.EXEMPTED_COOKIES.indexOf(cookieName) >= 0;
    if (isExempted) return true;
  }

  return false;
};

var deleteAllCookies = function deleteAllCookies(hostname) {
  if (!document) {
    return;
  }

  var cookies = document.cookie.split('; ');

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var host = hostname || window.location.hostname;
    var d = host.split('.'); // If the cookie name is in the list of exemption, don't delete it

    var isExempted = checkCookieExemption(cookie);

    if (isExempted) {
      // eslint-disable-next-line no-continue
      continue;
    }

    var count = 1;

    while (d.length > 0) {
      var domain = count % 2 === 0 ? ".".concat(d.join('.')) : d.join('.');
      var cookieBase = getCookieBase(cookie, domain);
      var cookieBaseWithoutDomainPath = getCookieBase(cookie);
      var p = window.location.pathname.split('/');
      clearCookie("".concat(cookieBase, "/;"), "".concat(cookieBaseWithoutDomainPath, "/;"));

      while (p.length > 0) {
        clearCookie("".concat(cookieBase + p.join('/'), ";"), "".concat(cookieBaseWithoutDomainPath + p.join('/'), ";"));
        p.pop();
      }

      if (count % 2 === 0) {
        d.shift();
        count = 1;
      } else {
        // eslint-disable-next-line no-plusplus
        count++;
      }
    }
  }
};

var deleteCookiesOverSize = function deleteCookiesOverSize(hostname, maxSize) {
  // Get all cookies.
  var allCookies = document.cookie.split(';'); // Initialize variables to keep track of the size and the cookies to delete.

  var totalSize = 0; // Iterate through each cookie to calculate the total size.

  allCookies.forEach(function (cookie) {
    var _cookie$split = cookie.split('='),
        _cookie$split2 = (0, _slicedToArray2.default)(_cookie$split, 2),
        cookieName = _cookie$split2[0],
        cookieValue = _cookie$split2[1];

    if (!cookieName || !cookieValue) {
      return;
    }

    var cookieSize = (cookieName.length + cookieValue.length) * 2; // Multiply by 2 for UTF-16 encoding.

    totalSize += cookieSize;
  });
  console.log('Total cookies size: ', totalSize);

  if (totalSize >= maxSize) {
    deleteAllCookies(hostname);
    console.log('Cookies deleted!');
  }
};

var deleteCookieIfExpired = function deleteCookieIfExpired(hostname, days) {
  var aaCookieExpiry = _utilities.default.getLocalStorage(_constant.LOCAL_STORAGE_EXPIRY_KEY);

  if (!aaCookieExpiry) {
    deleteAllCookies(hostname);
    return setLocalStorageCookieExpiryDate(days);
  }

  var expired = checkDateIfExpired(aaCookieExpiry);

  if (!expired) {
    return null;
  }

  deleteAllCookies(hostname);
  return setLocalStorageCookieExpiryDate(days);
};
/**
 * A utility function that will delete all user cookies after particular number of days
 * @param {string} hostname hostname or domain of the cookies you want to delete
 * @param {number} days number of days before next cookie reset happens
 * @param {boolean} enableCookieSizeThreshold enable or disable the deletion of cookies when it reach the size threshold
 * @param {number} cookieMaxSize cookie size threshold
 * @default
 * hostname = browser hostname
 * days = 60
 */


var cookieResetter = function cookieResetter(hostname) {
  var days = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constant.DEFAULT_EXPIRY_DAYS;
  var enableCookieSizeThreshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var cookieMaxSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constant.DEFAULT_COOKIE_SIZE_THRESHOLD;

  if (enableCookieSizeThreshold) {
    deleteCookiesOverSize(hostname, cookieMaxSize);
  } else {
    deleteCookieIfExpired(hostname, days);
  }
};

var _default = cookieResetter;
exports.default = _default;